module.exports = __webpack_public_path__ + "static/media/help.9a96a54f.ogv";